import { Spin } from 'components/UI';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { routesApi } from 'routes/api';
import { useStore } from 'stores/RootStore';

const SmartRouter = observer(() => {
  const { smartSearchStore } = useStore();
  const { fetchError } = smartSearchStore.fetchStatus;
  const searchedItem = new URLSearchParams(window.location.search).get('search');

  useEffect(() => {
    if (searchedItem) {
      // Keeps the query so the "Not found" fallback can land on the search page instead of a dead blank screen.
      smartSearchStore.setQuery(searchedItem);
      void smartSearchStore.fetch(routesApi.smartSearchPath(searchedItem));
    }
  }, [smartSearchStore, searchedItem]);

  if (!searchedItem) {
    return <div className="m-t-md">The link is missing a search code, so there is nothing to open.</div>;
  }

  if (fetchError) {
    return <div className="m-t-md">Failed to resolve the link. Please reload the page to try again.</div>;
  }

  return <Spin size="large" />;
});

export default SmartRouter;
